<template>
    <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3">
            <ProfilePage :data-set="dataSet" @click-banner="clickBanner"  />
    </div>

</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { ProfilePoupData } from './supportScript';
import ProfilePopupOne from '@/themes/themeOne/profile/profilePopup.vue';
import ProfilePopupTwo from '@/themes/themeTwo/profile/profilePopup.vue';
import ProfilePage from '@/themes/themeThree/profile/profilePage.vue';
import { HOME_COMPONENT_ID } from '../home/supportScript';
import { useThemeStore } from '@/stores/theme';

const userStore = useUserStore()
const themeStore = useThemeStore();
const componentIdsInOrderConfig = ref(HOME_COMPONENT_ID);
const show = ref(false)
const isPopping = ref(false)
const componentList = ref([])

const dataSet = computed<ProfilePoupData>(() => ({
    show: show.value,
    isPopping: isPopping.value,
    componentList: componentList.value,
    componentIdsInOrderConfig: componentIdsInOrderConfig.value,
}))

onMounted((list: any) => {
    componentList.value = list
    show.value = true
    userStore.getInfo()
})
const emits = defineEmits(['openAgentPopup'])
const clickBanner = () => {
    isPopping.value = true
    setTimeout(() => {
        isPopping.value = false
        emits('openAgentPopup')
    }, 300)

}

</script>